import { z } from "zod"

// Zod v4 compiles validators with `new Function(...)` for performance, which
// is blocked by our CSP (no `'unsafe-eval'`). `jitless: true` disables the
// codegen path and falls back to the interpreted validator. Imported as a
// side effect from the app entry so it runs before any schema is parsed.
z.config({ jitless: true })
